var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobileHead",attrs:{"id":"head"}},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/logo.png"),"alt":""},on:{"click":_vm.backEvent}}),_vm._v(" "),_c('img',{staticClass:"menu",attrs:{"src":require("@/assets/images/icon_more.png"),"alt":""},on:{"click":_vm.menuEvent}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a84104dc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/publicCom/mobileHead.vue
// module id = null
// module chunks = 